import { useEffect, useState } from 'react';
import ContactService from '../../../services/contact_service';

const PAGE_SIZE = 15;

const Users = (vm) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));

  const getRoleParams = (roleParam) => {
    const currentRole = roleParam ?? vm.findRole ?? 'Todos';
    const ignore = currentRole === 'Todos' && vm.canSeeAdmin;

    return {
      ignore,
      roles: vm.canSeeAdmin
        ? (currentRole === 'Todos' ? 'Super Administrador' : currentRole)
        : 'Usuario',
    };
  };

  const fetchUsers = async ({ p = page, filter = null, role = 'Todos' } = {}) => {
    setLoading(true);
    try {
      const cleanFilter = filter !== null ? filter : (vm.query.trim().toLowerCase() || null);
      const { ignore, roles: rolesFilter } = getRoleParams(role);
      const pageUser = await ContactService.getAll({
        page: p,
        pageSize: PAGE_SIZE,
        filter: cleanFilter,
        sort: vm.sortConfig,
        roles: rolesFilter,
        ignore,
      });
      if (vm.logout(pageUser)) return;
      const contacts = pageUser.contacts || [];
      const totalFromApi = Number(pageUser.total) || 0;
      const srvPage = Number(pageUser.page) || p;
      const totalPagesSrv = Math.max(1, Math.ceil(totalFromApi / PAGE_SIZE));
      setTotal(totalFromApi);
      setUsers(contacts);
      if (srvPage > totalPagesSrv) setPage(totalPagesSrv);
      else if (srvPage !== p) setPage(srvPage);
    } catch (e) {
      vm.message(e?.message || e, 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    vm.onResetSelection();
    setPage(1);
  }, [vm.query, vm.sortConfig, vm.findRole]);

  useEffect(() => {
    fetchUsers({
      p: page,
      filter: vm.query.trim().toLowerCase() || null,
      role: vm.findRole,
    });
  }, [page, vm.query, vm.sortConfig, vm.findRole]);

  const goToPage = (p) => {
    setPage(Math.max(1, Math.min(totalPages, p)));
  };

  return {
    PAGE_SIZE,
    users,
    loading,
    page,
    total,
    totalPages,
    setPage,
    fetchUsers,
    goToPage,
  };
};

export default Users;
